<template>
    <BaseFCPSelect elementId="SearchTypes" label="I am looking for a" :items="items" v-model="type" />
</template>
  
<script setup>

  /**
   * This component manages the search type or the 'I am looking for a' select control on the search page.  It synchronizes
   * the selection with the underlying context attribute in the model.
   */

    const { cleanContext } = useModelBuilder()
    const { criteriaContext, profile } = useFCPModel()
    const { items } = useSearchTypes(profile.value, criteriaContext.value)
    const criteriaType = computed(() => criteriaContext.value.type)

    const type = ref(criteriaType.value)

    watch(type, () => {

      const latLong = criteriaContext.value.latLong
      const where = criteriaContext.value.where
      const hWhere = criteriaContext.value.hWhere
      const careNetworkId = criteriaContext.value.careNetworkId
      const networkId = criteriaContext.value.networkId
      const tier = criteriaContext.value.tier
      const asOfDate = criteriaContext.value.asOfDate
      const marketingGroup = criteriaContext.value.marketingGroup

      const newContext = cleanContext()

      //Let's update the context with the new type value and maintain a few key values such as the latLong, where, and hWhere
      newContext.type = type.value
      newContext.latLong = latLong
      newContext.where = where
      newContext.hWhere = hWhere
      newContext.careNetworkId = careNetworkId
      newContext.networkId = networkId
      newContext.asOfDate = asOfDate

      if (marketingGroup) newContext.marketingGroup = marketingGroup

      //Make sure to copy the tier since we default the tier in useFCPModel if a PCC plan.
      newContext.tier = tier
      criteriaContext.value = newContext

        // criteriaContext.value.cc = []
        // criteriaContext.value.code = ''
        // if(type.value == 'urgent') {
        //   // if the type switches to urgent care, we need to clear out the term
        //   // otherwise, care concepts were being applied to urgent care searches even though we hid the 'to help me with'
        //   criteriaContext.value.term = ''
        // }
    })
  
    onMounted(() => {
      //Check to see whether we have a type value set yet in the context.  If not, we will need to add it.  Also, if
      //The value in the context.type is not valid - i.e. in in the list of options, default to one that is.
      const found = items.value.find((i) => i.value == criteriaContext.value.type)
      if (!found) criteriaContext.value.type = items.value[0].value
    })

  </script>
  
  <style lang="scss">
  hp6-select hp6-label-decorator {
    line-height: 1.15;
  }
  </style>